// src/components/common/AlertToast.tsx
import React from 'react';
import { useAlert } from '../../contexts/AlertContext';
import { AlertType } from '../../types/Alert';
import styles from './AlertToast.module.css';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const AlertToast: React.FC = () => {
  const { alerts, removeAlert } = useAlert();

  const getIcon = (type: AlertType) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className={styles.successIcon} />;
      case 'error':
        return <XCircleIcon className={styles.errorIcon} />;
      case 'warning':
        return <ExclamationTriangleIcon className={styles.warningIcon} />;
      case 'info':
        return <InformationCircleIcon className={styles.infoIcon} />;
      default:
        return <InformationCircleIcon className={styles.infoIcon} />;
    }
  };

  const getAlertStyle = (type: AlertType) => {
    switch (type) {
      case 'success':
        return styles.success;
      case 'error':
        return styles.error;
      case 'warning':
        return styles.warning;
      case 'info':
        return styles.info;
      default:
        return styles.info;
    }
  };

  if (alerts.length === 0) return null;

  return (
    <div className={styles.toastContainer}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`${styles.alert} ${getAlertStyle(alert.type)}`}
        >
          <div className={styles.alertContent}>
            <div className={styles.alertIcon}>
              {getIcon(alert.type)}
            </div>
            <div className={styles.alertText}>
              <div className={styles.alertTitle}>{alert.title}</div>
              {alert.message && (
                <div className={styles.alertMessage}>{alert.message}</div>
              )}
            </div>
          </div>
          <button
            onClick={() => removeAlert(alert.id)}
            className={styles.closeButton}
            aria-label="Cerrar notificación"
          >
            <XMarkIcon className={styles.closeIcon} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AlertToast;